<template>
  <div>
    <b-modal
        id="email-preview-modal"
        centered
        :title="$t('pages.template_builder.preview_modal.title')"
        title-class="font-18"
        size="md"
        ok-only
        :ok-title="$t('pages.template_builder.preview_modal.ok')"
        :cancel-title="$t('pages.template_builder.preview_modal.cancel')"
        @change="isVisible"
    >
      <div class="px-2">
        <b-row>
          <b-col cols="12" class="pt-3 subject-bar" style="background-color: rgb(85, 110, 230)">
            <h6 class="mt-0 mb-3 font-size-16 text-white">
              <i class="mdi mdi-email"></i>
              {{ subject }}
            </h6>
          </b-col>
          <b-col cols="12" class="bg-light content-bar">
            <div class="mt-3 mb-4" v-html="content"/>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import logo from '@/assets/images/demo-logo.png'
import * as Mustache from "mustache"

export default {
  name: "EmailPreview",
  props: ['selectedTemplate'],
  data() {
    return {
      translations: {
        buyer_name: 'John Doe',
        company_name: 'Example Company',
        logo_image: `<img width="80px" src="${logo}"/>`,
        order_id: '000-000000-0000000',
        order_purchase_date: '2021/01/01',
        order_item_count: '1',
        order_total_price: '19.99',
        earliest_ship_date: '2021/01/03',
        item_title: 'Example Item Title',
        latest_ship_date: '2021/01/03',
        earliest_delivery_date: '2021/01/03',
        product_list: '<div><span>Details of your order:</span><ul><li><span>Item 1... </span>(<a href="https://www.amazon.com.tr/review/review-your-purchases/error?_encoding=UTF8&asins=B000000000">Leave Product Review</a>)</li></ul></div>',
        contact_seller: '<a href="https://www.amazon.com.tr/gp/help/contact/contact.html?ie=UTF8&assistanceType=order&marketplaceId=A33AVAJ2PDY3EV&orderId=000-000000-0000000&recipientId=00000000000000&ref_=&step=submitEntry&subject=2">Contact Us</a>',
        product_review_request: '<a href="https://www.amazon.com.tr/review/review-your-purchases/error?_encoding=UTF8&asins=B000000000">Leave Product Review</a>',
        feedback_request: '<a href="https://www.amazon.com.tr/hz/feedback/?_encoding=UTF8&orderID=000-000000-0000000">Leave Feedback</a>',
        feedback_removal: '<a href="https://www.amazon.com.tr/gp/feedback/leave-consolidated-feedback.html?ie=UTF8&marketplaceID=A33AVAJ2PDY3EV&mode=submitted&orderID=000-000000-0000000">Leave Product Review</a>',
      },
      content: this.$t('pages.template_builder.preview_modal.content'),
      subject: this.$t('pages.template_builder.preview_modal.subject'),
    }
  },
  methods: {
    isVisible() {
      if (this.selectedTemplate?.subject && this.selectedTemplate.subject) {
        this.subject = this.compile(this.selectedTemplate.subject)
      }
      if (this.selectedTemplate?.content && this.selectedTemplate.content) {
        this.content = this.compile(this.selectedTemplate.content)
      }
    },
    compile(template) {
      return  Mustache.render(template, this.translations)
    }
  }
}
</script>

<style scoped>
.subject-bar{
  border-radius: 6px 6px 0 0;
}
.content-bar{
  border-radius: 0 0 6px 6px;
}
</style>